import React from 'react'
import SignIn from '../pages/auth/signin';
import { Routes, Route, Navigate} from 'react-router-dom';
import { HomeRoute } from './homeRoute';
import { Appointments } from './appointment';
import { Registration } from './registration';
import { Patients } from './patient';
import { PackageHistorys } from './package';
import { DoctorReviews } from './review';
import { Products } from './produk';
import { PointSales } from './pos';

function AppRoutes() {
  return (
    <Routes>
      <Route path='/' element={
        !localStorage.getItem('access_token') 
        ?<SignIn /> : <Navigate to="/dashboard" replace />}/>
      <Route path='dashboard/*' element={<HomeRoute />} />
      <Route path='appointment/*' element={<Appointments />} />
      <Route path='registration/*' element={<Registration />} />
      <Route path='patient/*' element={<Patients />} />
      <Route path='package-history/*' element={<PackageHistorys />} />
      <Route path='doctor-review/*' element={<DoctorReviews />} />
      <Route path='product/*' element={<Products />} />
      <Route path='pos/*' element={<PointSales />} />
    </Routes>
  )
}

export default AppRoutes;